import React, {Component} from "react";
export interface TooltipProps
{
    symbol?: string;
    message: string;
}


export class Tooltip extends Component<TooltipProps> {
    tooltipComponent = () => {
        const {symbol, message, children} = this.props;
        var hasSymbol = symbol ? true : false;
        var isWrapper = children ? true : false;

        if(isWrapper) {
            return (<span className="tooltip" data-message={message}> {children} </span>);
        } else {
            return (<div data-tip={message} className="tooltip-symbol tooltip" >{hasSymbol ? symbol : "?"}</div>);
        } 
    }

    public render = () => {
        return (
            this.tooltipComponent()
        );
    }
}
